import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHome,
  faInfoCircle,
  faGlobe,
  faBars,
  faMoneyBill1Wave
} from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import CartDropdown from './CartDropdown';
import MenuModal from './MenuModal';
import { useCart } from '../context/CartContext'; // Import the useCart hook

const Header = () => {
  const { t, i18n } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Get cart count from context
  const { cartItems } = useCart(); // Get cart items from context
  const cartCount = cartItems.length; // Count cart items

  // Change language logic
  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang) {
      i18n.changeLanguage(savedLang);
      document.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
    }
  }, [i18n]);

  // Handle language change
  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    document.dir = lang === 'ar' ? 'rtl' : 'ltr';
    localStorage.setItem('language', lang);
  };

  return (
    <header className="bg-white border-b shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-2 flex justify-between items-center">
        <Link to="/" className="flex-col items-center gap-2">
          <img src="/logo1.png" alt="Logo" className="h-20" />
          <p className='text-xs'>{t('header.announcement')}</p>
        </Link>

        {/* Mobile Menu */}
        <div className="lg:hidden">
          <details className="dropdown dropdown-end">
            <summary className="btn btn-sm btn-outline text-[#FF9900] border-[#FF9900] hover:bg-[#FF9900] hover:text-white">
              <FontAwesomeIcon icon={faBars} />
            </summary>
            <ul className="menu menu-sm dropdown-content mt-3 p-2 shadow bg-white rounded-box w-56">
              <li><Link to="/"><FontAwesomeIcon icon={faHome} /> {t('header.nav.home')}</Link></li>
              <li><Link to="/most-discounted"><FontAwesomeIcon icon={faMoneyBill1Wave} /> {t('banner.buttonText')}</Link></li>
              <li><button onClick={() => setIsModalOpen(true)}><FontAwesomeIcon icon={faBars} /> {t('header.nav.categories')}</button></li>
              <li>
                {/* Cart Dropdown in mobile menu */}
                <CartDropdown />
              </li>
              <li><Link to="/about"><FontAwesomeIcon icon={faInfoCircle} /> {t('header.nav.about')}</Link></li>
              <li>
                <button onClick={() => changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}>
                  <FontAwesomeIcon icon={faGlobe} /> {i18n.language === 'en' ? 'العربية' : 'English'}
                </button>
              </li>
            </ul>
          </details>
        </div>

        {/* Desktop Menu */}
        <div className="hidden lg:flex gap-4 items-center">
          <Link className="text-gray-800 hover:text-[#FF9900] transition" to="/"><FontAwesomeIcon icon={faHome} /> {t('header.nav.home')}</Link>
          <Link className="text-gray-800 hover:text-[#FF9900] transition" to="/most-discounted"><FontAwesomeIcon icon={faMoneyBill1Wave} /> {t('banner.buttonText')}</Link>
          <button className="text-gray-800 hover:text-[#FF9900] transition" onClick={() => setIsModalOpen(true)}>
            <FontAwesomeIcon icon={faBars} /> {t('header.nav.categories')}
          </button>

          {/* Cart Dropdown in desktop menu */}
          <CartDropdown />

          <Link className="text-gray-800 hover:text-[#FF9900] transition" to="/about"><FontAwesomeIcon icon={faInfoCircle} /> {t('header.nav.about')}</Link>
          <button
            className="text-gray-800 hover:text-[#FF9900] transition"
            onClick={() => changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}
          >
            <FontAwesomeIcon icon={faGlobe} /> {i18n.language === 'en' ? 'العربية' : 'English'}
          </button>
        </div>
      </div>

      {isModalOpen && <MenuModal onClose={() => setIsModalOpen(false)} />}
    </header>
  );
};

export default Header;